import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/es5/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#2196F3',
        secondary: '#111E43',
        accent: '#8c9eff',
        header: '#111E43',
        bg: '#FAFAFA',
        grey: '#B8B8B8',
        window: '#FFFFFF',
        work_card: '#FFFFFF',
        text_header: '#FFFFFF',
        text_content: '#000000',
        text_light: '#757575',
        border0: '#E8E9ED',
        border1: '#E0E0E0',
        border2: '#BDBDBD',
        hover1: '#FAFAFA',
        shadow: '#757575',
        success: '#33D4C0',
        warning: '#FFBB00',
        error: '#FF789D'
      },
    },
  },
  lang: {
    locales: { de },
    current: 'de',
  },
});
